<div class="d-flex align-items-center gap-2 mb-2">
    <div class="w-50">
        <edl-floating-label-container label="Title" for="custom-form-title">
            <div class="input-group custom-form-title-input-group">
                <input id="custom-form-title" type="text" class="form-control" formControlName="CustomFormTitle" readonly/>
                <button type="button" (click)="onCustomFormRemoved()" class="btn btn-warning">
                    <i class="fas fa-trash-alt"></i>
                </button>
            </div>
        </edl-floating-label-container>
    </div>
    <div class="w-50" formGroupName="Paging">
        <paetep-search
            class="w-100"
            formControlName="SearchBy"
            [isBusy]="isBusy"
            (keyup.enter)="onSearchBy()"
            (onBlur)="onSearchBy()"
            (onReset)="onReset()"
        ></paetep-search>
    </div>
</div>
<paetep-custom-form-selector formControlName="CustomFormId" [customFormSelectorDTOs]="pagedResponse?.Results ?? []" [busy]="reloadQueue.isLoading" (onFieldSelected)="onFieldSelected($event)" (onCustomFormSelected)="onCustomFormSelected($event)"></paetep-custom-form-selector> 
<div *ngIf="pagedResponse" class="content mt-2">
    <div class="row">
        <div class="col-sm-12 text-end">
            <edl-pagination *ngIf="pagedResponse.TotalNumberPages > 1"
                            [collectionSize]="pagedResponse.TotalCount"
                            [page]="getPagingControl('CurrentPage')?.value"
                            [pageSize]="pagedResponse.Limit"
                            (pageChange)="onPageChange($event)"></edl-pagination>
        </div>
    </div>
</div>


